function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "High-Fi-",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "REJ2--krok1-",
  transform: "translate(-25.000000, -624.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "#FFFFFF",
  x: 0,
  y: 0,
  width: 414,
  height: 896
}), /*#__PURE__*/React.createElement("g", {
  id: "Row",
  transform: "translate(25.000000, 604.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon/Number",
  transform: "translate(0.000000, 20.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Safespace",
  x: 0,
  y: 0,
  width: 24,
  height: 24
}), /*#__PURE__*/React.createElement("g", {
  id: 3,
  transform: "translate(0.000000, 1.200000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#48A9A1",
  opacity: 0.2,
  x: 5.616,
  y: 4.8,
  width: 9.492,
  height: 12.84
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.692,0.143992946 L3.792,0.143992946 C3.54678557,0.143992946 3.34782827,0.342785571 3.34782827,0.588 L3.34782827,18.648 C3.3446529,18.7667506 3.39035567,18.8816389 3.47435837,18.9656416 C3.55836108,19.0496443 3.6732494,19.0953471 3.792,19.0921717 L22.692,19.0921717 C22.8118213,19.0952396 22.927862,19.0498953 23.0137418,18.9662754 C23.0996217,18.8826555 23.1480438,18.7678651 23.148,18.648 L23.148,0.648 C23.1616584,0.518985148 23.1197159,0.390260238 23.0326744,0.294056483 C22.9456329,0.197852727 22.8217338,0.143279028 22.692,0.143992946 Z M13.308,15.888 C12.4906782,16.4463327 11.5124349,16.7204094 10.524,16.668 C9.83206319,16.668706 9.14409545,16.5634874 8.484,16.356 C7.90279704,16.1905238 7.36304362,15.9042909 6.9,15.516 L7.62,13.896 C8.42207553,14.525813 9.40833243,14.8756392 10.428,14.892 C10.9028713,14.929876 11.3775449,14.8164584 11.784,14.568 C12.0848949,14.313784 12.241866,13.9280838 12.204,13.536 C12.2383496,13.1582461 12.0805399,12.7885205 11.784,12.552 C11.3727259,12.3163806 10.9008923,12.2078172 10.428,12.24 L8.952,12.24 L8.952,10.488 L10.152,10.488 C10.6172875,10.5204989 11.0815464,10.4117536 11.484,10.176 C11.8109759,9.97869492 12.0077172,9.62181534 12,9.24 C12.0272204,8.87434923 11.8857763,8.51631875 11.616,8.268 C11.3022396,8.03332225 10.9149794,7.91842088 10.524,7.944 C10.060763,7.94828172 9.60184606,8.03356718 9.168,8.196 C8.68682797,8.37343406 8.23407315,8.62002373 7.824,8.928 L7.044,7.32 C7.50744573,6.9323065 8.04706602,6.64614423 8.628,6.48 C9.26768605,6.2733605 9.93576632,6.16808725 10.608,6.168 C11.2334923,6.156979 11.8545026,6.27546124 12.432,6.516 C12.9138145,6.71763616 13.3295176,7.05019867 13.632,7.476 C13.9138185,7.90721628 14.0600975,8.41292373 14.052,8.928 C14.1130737,9.99394851 13.462623,10.9720698 12.456,11.328 C13.0046061,11.4631601 13.4911237,11.7804542 13.836,12.228 C14.1615158,12.6864382 14.3299076,13.2379211 14.316,13.8 C14.3351293,14.6175584 13.9600693,15.3944685 13.308,15.888 L13.308,15.888 Z",
  id: "Shape",
  fill: "#48A9A1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.4,21.456 L1.452,21.456 C1.12062915,21.456 0.852,21.1873708 0.852,20.856 L0.852,2.856 C0.852,2.52462915 1.12062915,2.256 1.452,2.256 L20.4,2.256 C20.7313708,2.256 21,2.52462915 21,2.856 L21,20.856 C21,21.1873708 20.7313708,21.456 20.4,21.456 Z M2.1,20.256 L19.752,20.256 L19.752,3.456 L2.052,3.456 L2.1,20.256 Z",
  id: "Shape",
  fill: "#555150"
}))))));

var SvgThird = function SvgThird(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgThird, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Third.dcd32624.svg";
export { ForwardRef as ReactComponent };